/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".brand-image[_ngcontent-%COMP%]{height:50px}.kortojura-icon[_ngcontent-%COMP%]{width:40px;height:40px;margin-right:12px;margin-left:12px;vertical-align:text-bottom}.app-header-inner[_ngcontent-%COMP%]{background:linear-gradient(335deg,#feb692 10%,#9c3329 100%) center center/cover no-repeat fixed!important;background-image:url(trianglify.cdab8e7b9a0fd3e7455b.svg)!important}"];
export { styles as styles };
